const Tilda = () => (
  <svg
    width="33"
    height="11"
    viewBox="0 0 33 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3563 3.43656C7.03675 -2.96226 -1.15364 2.89709 0.133503 6.06391C8.68072 1.53574 10.9029 10.6548 20.9869 11C30.0134 10.6681 33.2225 5.34944 32.9881 0.645071C32.8056 -3.01536 28.5991 10.4086 17.3563 3.43656Z"
      fill="#F6B300"
    />
  </svg>
);
export default Tilda;
